import pagination from "../static/pagination";

export default {
    setListRiwayatPembayaran: (state, payload) => {
        state.listPembayaranEdc = state.listPembayaranEdc.concat(payload.main_data);
        state.totalPembayaranEdc = payload.length;
    },
    resetListRiwayatPembayaran: (state) => {
        state.listPembayaranEdc = [];
        state.totalPembayaranEdc = "";
    },
    resetPaginationRiwayatPembayaran: (state) => {
        state.paginationRiwayatPembayaran = pagination();
    },
    setNextPaginationRiwayatPembayaran: (state, payload) => {
        state.paginationRiwayatPembayaran.length += payload.length;
        state.paginationRiwayatPembayaran.pageNumber++;
        state.paginationRiwayatPembayaran.offset =
            state.paginationRiwayatPembayaran.pageNumber * state.paginationRiwayatPembayaran.limit;
    },
    setEndPembayaranOfPage: (state, payload) => {
        state.endPembayaranOfPage = payload;
    },
};
